import { render, staticRenderFns } from "./Simple-ItemTable.vue?vue&type=template&id=a4592262&"
import script from "./Simple-ItemTable.vue?vue&type=script&lang=js&"
export * from "./Simple-ItemTable.vue?vue&type=script&lang=js&"
import style0 from "./Simple-ItemTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports